import Button from '@oncolens/oncolens-ui/lib/components/FormControls/Button';
import TextInput from '@oncolens/oncolens-ui/lib/components/FormControls/TextInput';
import useDebounce from '@oncolens/oncolens-ui/lib/hooks/common/useDebounce';
import React, { useState } from 'react';
import { BsPlusCircle, BsSearch } from 'react-icons/bs';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useNavigate } from 'react-router';
import QipMetricQuestionsTable from '../components/QipMetricQuestionsTable';

export const QipMetricQuestionsList = () => {
  const [queryValue, setQueryValue] = useState('');
  const [inputValue, setInputValue] = useState('');
  const debouncedSearch = useDebounce((value: string) => setQueryValue(value), 500);
  const navigate = useNavigate();

  return (
    <div className="h-2/3" data-cy="qip-metric-questions-table">
      <div className="flex items-center my-3">
        <div className="relative w-1/3 ml-auto">
          <BsSearch className="absolute left-2.5 top-2.5 text-gray-700 z-10" />
          <TextInput
            placeholder="Search By Name"
            label="search"
            srLabel={true}
            inputProps={{ className: 'pl-8' }}
            type="text"
            id="qipMetricQuestionsSearch"
            htmlName="qipMetricQuestionsSearch"
            value={inputValue}
            testSelector="filter-qipMetricQuestions-input"
            onChange={(event: any) => {
              const value = event.target.value as string;

              setInputValue(value);
              debouncedSearch(value);
            }}
          />
        </div>
        <Button
          onClick={() => navigate('add')}
          buttonColor="blue"
          className="flex items-center w-auto py-1.5 ml-2"
          testSelector="add-qipMetricQuestions-button">
          <BsPlusCircle className="mr-2" /> Add New
        </Button>
      </div>

      <QipMetricQuestionsTable searchQuery={queryValue} />
    </div>
  );
};
